// authService.ts
import apiService from './api';
import { LoginCredentials, User } from '../types/authTypes';

export interface DataResponse {
    user: User;
    token: string;
}

export interface ErrorResponse {
    error: string;
}

export interface AuthResponse {
    status: boolean;
    data: DataResponse;
}

class AuthService {
    async login(credentials: LoginCredentials): Promise<AuthResponse> {
        // try {
        const response = await apiService.post<DataResponse>('/auth/login', credentials);

        console.log("response::::::", response)

        if (!response.status) {
            throw new Error('Login failed');
        }

        const successData = response.data;
        this.setToken(successData.token);
        this.setUser(successData.user);

        return {
            status: response.status,
            data: successData,
        };
        // }
    }

    // Local storage helpers
    setToken(token: string): void {
        localStorage.setItem('token', token);
    }

    getToken(): string | null {
        return localStorage.getItem('token');
    }

    setUser(user: User): void {
        localStorage.setItem('user', JSON.stringify(user));
    }

    getUser(): User | null {
        const userStr = localStorage.getItem('user');
        return userStr ? JSON.parse(userStr) : null;
    }

    isAuthenticated(): boolean {
        return !!this.getToken();
    }

    clearAuth(): void {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
    }
}

export const authService = new AuthService();
export default authService;